<template>
  <div class="docs-header-mobile no-padding">
    <div v-if="showFilter === 'SI'" class="filter col-24 col-sm-8 offset-sm-8 no-padding">
      <div class="select-wrapper">

        <select v-model="months">
          <option v-for="(item, index) in listMonths" :value="item" :key="index">
            {{ getLabel(item) }}
          </option>
        </select>


      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocsHeaderMobile',
  props: ['route', 'showFilter', 'title', 'defaultMonths'],
  data() {
    return {
      docs: [],
      loading: false,
      listMonths: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      months: 2
    }
  },
  i18n: {
    messages: {
      it_IT: {
        docsHeader: {
          label: 'Ultimi {months} Mesi'
        }
      },
      fr_FR: {
        docsHeader: {
          label: 'Derniers {months} mois'
        }
      },
      es_ES: {
        docsHeader: {
          label: 'Últimos {months} meses'
        }
      },
      de_DE: {
        docsHeader: {
          label: 'Letzten {months} Monaten'
        }
      },
      en_GB: {
        docsHeader: {
          label: 'Ultimi {months} Mesi'
        }
      }
    }
  },
  watch: {
    months: function () {
      this.changeMonth(this.months)
    },
    'defaultMonths': function (newVal, oldVal) {
      this.months = parseInt(newVal)
    }
  },
  computed: {
    showBack: function () {
      let root = this.$route.path
      if (this.$route.path.length === 1) {
        return false
      } else if (this.$route.name === 'DocumentiPers') {
        return false
      } else {
        return true
      }
    }
  },
  mounted: function () {
  },
  methods: {
    changeMonth: function (month) {
      this.$emit('changeMonth', month)
    },
    getLabel: function (item) {
      return this.$i18n.t('docsHeader.label', { months: item })
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.docs-header-mobile {
  height: 100%;
  padding-left: 10px;
  padding-right: 10px;

  /*height: 60px;
    line-height: 30px;
    position: relative;
    cursor: pointer;
    padding-top: 15px;
    padding-bottom: 15px;
    display: block;
    .return {
      height: 30px;
      .set-font(@color: @greenRiva, @weight: bold);
      .fa-icon {
        float: left;
      }
    }*/
  .filter {
    height: 50px;
    padding-top: 10px;

    .select-wrapper {
      position: relative;
      display: inline-block;
      width: 100%;

      &:after {
        content: '\0025BC';
        // font: normal normal normal 12px/1 FontAwesome;
        color: #cbb385;
        right: 8%;
        top: -3px;
        height: 26px;
        padding: 15px 0px 0px 8px;
        position: absolute;
        pointer-events: none;
      }

      select {
        .set-font(@size: 18px, @weight: bold, @color: @textTable, @family: 'os-bold');
        width: 90%;
        padding-right: 24px;
        background-color: #fff;
        border-radius: 5px;
        border-color: #cbb385;
        //font-family: Arial, ArialHebrew, sans-serif;
        //font-size: 18px;
        text-align: -moz-center;
        text-align: -webkit-center;
        text-align: center !important;
        //color: #cbb385;
        margin: 3px;
        padding: 3px;
        -webkit-appearance: none;

        &:focus {
          outline: none;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/Documenti/DocsHeaderMobile.vue